import { Button, Form, Input, Modal, Row, Typography } from 'antd';
import { ModalCustom } from 'components/common';
import React, { useEffect, useImperativeHandle, useState } from 'react';

const CancelModal = React.forwardRef((props : any, ref) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  useImperativeHandle(ref, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
  }));
  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    props.onCancelOk()
    closeModal()
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {

  }, [])
  return (
    <div>
      <ModalCustom
        wrapClassName="modal-custom"
        title="Hủy khám"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={closeModal}
        width={640}
      >
        <Form >
          <Row>
            <Form.Item
                label={<Typography.Text ellipsis>Lý do huỷ khám</Typography.Text>}
                name="lyDoHuyKham"
                labelAlign="left"
                labelCol={{span: 6}}
                wrapperCol={{span: 18}}
              >
                <Input
                  className="data-input-field"
                  size="large" 
                />
              </Form.Item>
          </Row>
          <Row justify='end' style={{marginTop: "4px"}}>
            <Button type="primary" danger onClick={closeModal}>Đóng</Button>
            <Button type="primary" onClick={handleOk}>Huỷ khám</Button>
          </Row>
        </Form>
      </ModalCustom>
    </div>
  );
})

export default CancelModal;